import Main from '@/views/common/main'
// 数据报表
export default [
    //'数据报表'
    {
        path: '/Report',
        name: 'Report',
        meta: {
            icon: 'ios-apps',
            title: '数据报表'
        },
        component: Main,
        children: [
            // 盘口数据统计
            {
                path: 'GameCompare',
                name: 'Report_GameCompare',
                meta: { title: '游戏时段数据表' },
                component: () => import('@/views/Report/GameCompare.vue')
            },
            // 盘口子游戏数据监控
            {
                path: 'GameLossInfo',
                name: 'Report_GameLossInfo',
                meta: { title: '盘口子游戏数据监控' },
                component: () => import('@/views/Report/GameLossInfo.vue')
            },
            {
                path: 'BriefDaily',
                name: 'Report_BriefDaily',
                meta: { title: '盘口简版日报数据' },
                component: () => import('@/views/Report/BriefDaily.vue')
            },
            {
                path: 'MarketData',
                name: 'Report_MarketData',
                meta: { title: '大盘数据统计' },
                component: () => import('@/views/Report/MarketData.vue')
            },
            {
                path: 'HandicapGameData',
                name: 'Report_HandicapGameData',
                meta: { title: '盘口子游戏数据' },
                component: () => import('@/views/Report/HandicapGameData.vue')
            },
            {
                path: 'HandicapRevenueData',
                name: 'Report_HandicapRevenueData',
                meta: { title: '盘口营收报表' },
                component: () => import('@/views/Report/HandicapRevenueData.vue')
            },
            {
                path: 'HandicapRetentionData',
                name: 'Report_HandicapRetentionData',
                meta: { title: '盘口留存数据' },
                component: () => import('@/views/Report/HandicapRetentionData.vue')
            },
            {
                path: 'HandicapAppendixData',
                name: 'Report_HandicapAppendixData',
                meta: { title: '盘口附录数据' },
                component: () => import('@/views/Report/HandicapAppendixData.vue')
            },
            {
                path: 'SummaryOfWinnings',
                name: 'Report_SummaryOfWinnings',
                meta: { title: '彩金汇总数据' },
                component: () => import('@/views/Report/SummaryOfWinnings.vue')
            },
            {
                path: 'GameCompareDay',
                name: 'Report_GameCompareDay',
                meta: { title: '盘口日对比数据' },
                component: () => import('@/views/Report/GameCompareDay.vue')
            },
            {
                path: 'HandicapChannelData',
                name: 'Report_HandicapChannelData',
                meta: { title: '盘口渠道报表' },
                component: () => import('@/views/Report/HandicapChannelData.vue')
            },
            {
                path: 'HandicapSummaryData',
                name: 'Report_HandicapSummaryData',
                meta: { title: '盘口汇总数据' },
                component: () => import('@/views/Report/HandicapSummaryData.vue')
            },
            {
                path: 'APIReport1',
                name: 'APIReport1',
                meta: { title: 'API统计报表' },
                component: () => import('@/views/Report/APIReport1.vue')
            },
            {
                path: 'APIReport2',
                name: 'APIReport2',
                meta: { title: 'API注单报表' },
                component: () => import('@/views/Report/APIReport2.vue')
            },
            {
                path: 'PackDataReport',
                name: 'PackDataReport',
                meta: { title: '盘口数据报表' },
                component: () => import('@/views/Report/PackDataReport.vue')
            },
            {
                path: 'TransferTotal',
                name: 'TransferTotal',
                meta: { title: '资金划转统计' },
                component: () => import('@/views/Report/TransferTotal.vue')
            },
            {
                path: 'TransferReport',
                name: 'TransferReport',
                meta: { title: '资金划转记录' },
                component: () => import('@/views/Report/TransferReport.vue')
            },
            {
                path: 'HandicapPromotionData',
                name: 'Report_HandicapPromotionData',
                meta: { title: '盘口推广数据' },
                component: () => import('@/views/Report/HandicapPromotionData.vue')
            },
            {
                path: 'HandicapRGamerData',
                name: 'Report_HandicapRGamerData',
                meta: { title: '盘口R类玩家数据' },
                component: () => import('@/views/Report/HandicapRGamerData.vue')
            },
            {
                path: 'ExclusiveData',
                name: 'Report_ExclusiveData',
                meta: { title: '专享10%数据表' },
                component: () => import('@/views/Report/ExclusiveData.vue')
            },
            {
                path: 'HandicapPromotionFee',
                name: 'Report_ HandicapPromotionFee',
                meta: { title: '盘口推广期费用统计' },
                component: () => import('@/views/Report/HandicapPromotionFee.vue')
            },
            {
                path: 'HandicapRRStatistics',
                name: 'Report_HandicapRRStatistics',
                meta: { title: '盘口营收留存统计' },
                component: () => import('@/views/Report/HandicapRRStatistics.vue')
            },
            {
                path: 'HandicapReplenData',
                name: 'Report_HandicapReplenData',
                meta: { title: '盘口补量数据' },
                component: () => import('@/views/Report/HandicapReplenData.vue')
            },
            {
                path: 'HandicapPromChannelData',
                name: 'Report_HandicapPromChannelData',
                meta: { title: '盘口推广渠道数据' },
                component: () => import('@/views/Report/HandicapPromChannelData.vue')
            },
            {
                path: 'TotalDataSum',
                name: 'Report_TotalDataSum',
                meta: { title: '总代每日明细表' },
                component: () => import('@/views/Report/TotalDataSum.vue')
            }
        ]
    }
]
